// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import AutoCompleteInput from '@/components/AutoCompleteInput'
import Pool from '@/components/Pool'
import FighterSlot from '@/components/FighterSlot'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import CoolSelect from 'vue-cool-select'
import CookieLaw from 'vue-cookie-law'

import VueAnalytics from 'vue-analytics'
import { messages } from './assets/lang'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import * as VueGoogleMaps from 'vue2-google-maps'
import Moment from 'vue-moment'
import store from './store'

const moment = require('moment')
require('moment/locale/de')
moment.locale('en')

Vue.config.productionTip = false

// register components FIRST
// Vue.component('autocomplete', Autocomplete)
// Vue.component('vue-resource', VueResource)

Vue.component('autocomplete-input', AutoCompleteInput)
Vue.component('pool', Pool)
Vue.component('fighter-slot', FighterSlot)
Vue.component('icon', Icon)
Vue.component('cookie-law', CookieLaw)
Vue.use(CoolSelect, {
  theme: 'material-design' // "bootstrap" or 'material-design'
})
Vue.use(VueResource)
Vue.use(VueI18n)
Vue.use(Moment, {moment})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBBcgga7nCvVyuyp2hBIU8cNC1rnm90GjE',
    libraries: 'places,drawing' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})
Vue.use(VueAnalytics, {
  id: 'UA-7607288-15',
  router
})

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages // set locale messages
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')

